/* components/UpsellProduct.ts


*/

import { CartItem, Component, Prop, Ref, log } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { cart } from '@/theme/Cart';

interface UpsellExceptions {
    "exceptionIds": string[];
}
@Component
export class UpsellProduct extends ThemeComponent {

    @Ref({required: false}) addButton!: HTMLButtonElement|null;
    @Ref({required: false}) hideButton!: HTMLDivElement|null;
    @Prop() upsellVariant!: number;
    @Prop() upsellDiscount!: number;
    @Prop() upsellExceptions!: UpsellExceptions;

    private upsellIsActive: boolean = true;

    private eligibleProductInCart = () => {

        // Get the cart contents
        const cartItems = cart.items;

        // Check for any eligible product
        // eslint-disable-next-line max-len
        const eligibleProduct = cartItems.find((item) => {
            if (item.properties && item.properties['_upsell_id']) {
                return Number(item.properties['_upsell_id']);
            }
        });

        return eligibleProduct ? true : false;
    };

    async init() {

        this.$subscribe(cart.onChange, () => {
            void this.checkCart();
        });

        this.addButton?.addEventListener('click', () => {
            this.addToCart().catch((err) => {throw new Error;});
        });

        this.hideButton?.addEventListener('click', () => {
            this.hideUpsell();
        });

    }

    async addToCart() {

        if (!this.eligibleProductInCart()) {
            this.upsellDiscount = 0;
        }

        await cart.addItem({
            id: this.upsellVariant,
            quantity: 1,
            properties: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                _upsellDiscount: `${this.upsellVariant}`,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                _upsellDiscountAmount: `${this.upsellDiscount}`
            }
        }).catch((err) => {
            // return err
        });

        this.classList.remove('upsell-product--active');
    }

    hideUpsell() {
        localStorage.setItem('hide-upsell-id', `${this.upsellVariant}`);
        this.classList.remove('upsell-product--active');
    }

    async removeFromCart(item: CartItem) {
        await cart.removeItem(item).catch((err) => {
            // return err
        });
    }

    async upgradeItem(item: CartItem) {
        await cart.changeItem(
            item,
            Number(item.quantity),
            {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                _upsellDiscountAmount: String(this.upsellDiscount)
            }
        ).catch((err) => {
            // console.log(err);
        });
    }

    async downgradeItem(item: CartItem) {
        await cart.changeItem(
            item,
            Number(item.quantity),
            {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                _upsellDiscountAmount: '0'
            }
        ).catch((err) => {
            // console.log(err);
        });
    }

    async checkCart() {

        try {

            // Get the cart contents
            const cartItems = cart.items;

            // Check for any eligible discount product
            // eslint-disable-next-line max-len
            const eligibleProduct = cartItems.find((item) => Number(item.properties['_upsell_id']));

            // Get any discounted upsell product
            const upsellDiscountProduct = cartItems.find(
                (item) => item.id == this.upsellVariant &&
                    item.properties &&
                    item.properties['_upsellDiscountAmount'] &&
                    Number(item.properties['_upsellDiscountAmount']) > 0);

            // Get any discounted upsell product
            const upsellProduct = cartItems.find(
                (item) => item.id == this.upsellVariant &&
                    item.properties &&
                    item.properties['_upsellDiscountAmount'] &&
                    Number(item.properties['_upsellDiscountAmount']) == 0);

            const cartHasException = cartItems.find(
                (item) => this.upsellExceptions.exceptionIds.includes(String(item.id))
            );

            if (!eligibleProduct && upsellDiscountProduct) {
                // If there is no eligible discount product in cart, remove
                // any discounted upsell product
                void this.removeFromCart(upsellDiscountProduct);
                this.upsellIsActive = false;
            } else if (eligibleProduct && upsellDiscountProduct) {
                this.upsellIsActive = false;
            } else if (cartHasException) {
                this.upsellIsActive = false;
            } else if (cart.items.length == 0) {
                this.upsellIsActive = false;
            } else {
                this.upsellIsActive = true;
            }

            const upsellIsHidden = localStorage.getItem('hide-upsell-id');

            if (this.upsellIsActive && !upsellIsHidden) {
                this.classList.add('upsell-product--active');
            } else {
                this.classList.remove('upsell-product--active');
            }

        } catch(err) {
            throw new Error();
        }


    }
}
